var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'Overlay Overlay-' + _vm.mode},[_c('div',{staticClass:"Overlay-mask",style:('background:' + _vm.colour + ';' +
            'opacity:'    + _vm.opacity)}),_c('div',{staticClass:"Overlay-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }